import { motion } from "framer-motion";
import { LANGS } from "../i18n/translations";
import { useLang } from "../i18n/LanguageContext";

export const LanguageSwitch = () => {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="language-selector"
      role="radiogroup"
      aria-label="Language"
      className="relative flex items-center rounded-full border border-white/10 bg-white/[0.04] p-1 backdrop-blur-xl"
    >
      {LANGS.map((l) => (
        <button
          key={l.code}
          role="radio"
          aria-checked={lang === l.code}
          data-testid={`lang-option-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`relative z-10 h-8 w-10 rounded-full font-mono text-[12px] font-medium tracking-wider transition-colors duration-300 ${
            lang === l.code ? "text-ink" : "text-zinc-400 hover:text-zinc-100"
          }`}
        >
          {lang === l.code && (
            <motion.span
              layoutId="lang-pill"
              className="absolute inset-0 -z-10 rounded-full bg-gold"
              transition={{ type: "spring", stiffness: 420, damping: 32 }}
            />
          )}
          {l.label}
        </button>
      ))}
    </div>
  );
};
